import { buildGumletUrl, GUMLET_PRESETS, type GumletImageParams } from '@/utils/gumlet';

const STUDIO_PLACEHOLDER_IMAGE = '/imgs/image-not-found.png';

export const replaceUnavailablePlaceholder = (src: string) =>
  src.includes('via.placeholder.com') ? STUDIO_PLACEHOLDER_IMAGE : src;

/**
 * Normalizes CMS image URLs and routes GCS assets through Gumlet at a size
 * matched to the rendered box. Without width/quality, Gumlet returns originals
 * (often 1–4 MB) and Lighthouse flags "Improve image delivery".
 */
export const resolveStorefrontImage = (
  src: unknown,
  fallback = STUDIO_PLACEHOLDER_IMAGE,
  gumlet: GumletImageParams = GUMLET_PRESETS.heroBackground,
): string => {
  if (typeof src !== 'string' || src.trim() === '') {
    return fallback;
  }

  const resolved = replaceUnavailablePlaceholder(src.trim());
  if (resolved === STUDIO_PLACEHOLDER_IMAGE || resolved.startsWith('/imgs/')) {
    return resolved;
  }

  return buildGumletUrl(resolved, gumlet);
};
